// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// Utils
import * as rectLib from '../../../../../common/maths/geometry/rect';
import { getStrokeBoundingRect } from '../drawingEditorUtils';

// Styles
import './DrawingEditorBoundingBoxDebugger.scss';

const DrawingEditorBoundingBoxDebugger = (props) => {
    const { paths, gridSize } = props;

    const padding = 2 * gridSize;

    const strokes = paths.map(get('stroke'));
    const strokeBoundingRects = strokes.map(getStrokeBoundingRect).map(rectLib.addPadding(padding, padding));

    return (
        <div className="DrawingEditorBoundingBoxDebugger">
            {strokeBoundingRects.map((boundingRect, index) => (
                <div key={index} className="path-bounding-rect-container" style={{ ...boundingRect }}>
                    <div className="path-bounding-rect" />
                </div>
            ))}
        </div>
    );
};

DrawingEditorBoundingBoxDebugger.propTypes = {
    paths: PropTypes.array,
    gridSize: PropTypes.number,
};

export default DrawingEditorBoundingBoxDebugger;
